export enum AdSlotClass {
	AD_CLASS = 'gpt-ad',
	AD_SLOT_PLACEHOLDER_CLASS = 'ad-slot-placeholder',
	HIDDEN_AD_CLASS = 'hidead',
}
